package one.healthium.insights.data.mapper

import one.healthium.insights.data.dto.MealNutritionDto
import one.healthium.insights.domain.models.MealNutritionModel

internal class MealNutritionMapper {
    fun dtoToModel(dto: MealNutritionDto): MealNutritionModel =
        MealNutritionModel(
            product = dto.product,
            portion = dto.portion,
            calories = dto.calories,
            fat = dto.fat,
            carbs = dto.carbs,
            fiber = dto.fiber,
            protein = dto.protein,
        )
}